/* =========================================================================
   parse-numeric-value.ts
   Extract numeric component from formatted KPI strings for count-up.
   ========================================================================= */

export interface ParsedNumber {
  raw: number;
  prefix: string;
  suffix: string;
  decimals: number;
}

export function parseNumericValue(str: string): ParsedNumber | null {
  const m = str.match(/^([^0-9\-]*)(-?[0-9,]*\.?[0-9]*)([^0-9]*)$/);
  if (!m) return null;
  const prefix = m[1];
  const numStr = m[2].replace(/,/g, "");
  const suffix = m[3];
  if (!numStr || numStr === "." || numStr === "-") return null;
  const raw = parseFloat(numStr);
  if (!Number.isFinite(raw)) return null;
  const decimals = (numStr.split(".")[1] || "").length;
  return { raw, prefix, suffix, decimals };
}

export function formatParsed(parsed: ParsedNumber, value: number): string {
  return `${parsed.prefix}${value.toLocaleString("en-AU", {
    minimumFractionDigits: parsed.decimals,
    maximumFractionDigits: parsed.decimals,
  })}${parsed.suffix}`;
}
